<template>
  <v-alert :value="visible">
    <v-layout
      class="mb-2"
      wrap
    >
      <v-flex
        xs12
        mb-3
      >
        <span class="fw-600 f-1">{{
          $t('alikes_families.p_e.alert.title', { fullName: fullName })
        }}</span>
      </v-flex>
      <v-flex xs12>
        <p class="mb-0 f-1">
          {{ $t('alikes_families.p_e.alert.text') }}
        </p>
      </v-flex>
    </v-layout>
  </v-alert>
</template>

<script>
import filters from '@/constants/filters';
export default {
    name: 'PreviousEditionDuplicateAlert',
    filters: {
        ...filters
    },
    props: {
        visible: {
            default: false
        },
        fullName: {
            type: String
        }
    },
    computed: {
        smAndDownScreen () {
            return this.$vuetify.breakpoint.smAndDown;
        }
    }
};
</script>

<style scoped></style>
